
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/visx",
      function () {
        return require("private-next-pages/components/visx.mdx");
      }
    ]);
  